/**
 * 资质状态枚举
 * @param status
 * @returns {string}
 */
export function getDrivingModeView(drivingMode) {
    if (drivingMode === 1){
        return '自动';
    }else if (drivingMode === 2){
        return '人工';
    }else if (drivingMode === 3){
        return '远程控制'
    }else if (drivingMode === 4){
        return '故障停车'
    }else {
        return '--'
    }
}